import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { CreateResource, getResources } from "../../api/satactApi";
import { Add, Close, Description } from "@mui/icons-material";
import CommonButton from "../../common/components/CommonButton";
import CommonDialog from "../../common/components/CommonDialog";
import Dropzone from "react-dropzone";

const RecentActivites = ({
    testType,
    fromMentor,
    studentId,
    currentService
}) => {
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.auth);
    const [resources, setResources] = useState([]);
    const [open, setOpen] = useState(false);
    const [fileNames, setFileNames] = useState([]);

    const getResourceData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getResources(testType, user?.student_id || studentId);
            setResources(response.data.map((a) => a.document_urls).flat());
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id || studentId) {
            getResourceData();
        }
    }, [testType, user]);

    const handleDrop = acceptedFiles => {
        setFileNames(acceptedFiles?.map(files => files));
    };

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonDialog
                open={open}
                size="xs"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Box>
                                <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Upload Resources</Typography>
                            </Box>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setFileNames([]);
                                    setOpen(false);
                                }}
                            />
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container mt={2} mb={2}>
                        <Box sx={{ width: '100%' }}>
                            {fileNames.length > 0 ? (
                                // Show selected files
                                <Box sx={{ mt: 2 }}>
                                    {fileNames.map((file, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                border: '1px solid',
                                                borderColor: 'grey.300',
                                                borderRadius: 1,
                                                mb: 1,
                                                backgroundColor: 'background.paper'
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Description color="primary" />
                                                <Box>
                                                    <Typography variant="body1">{file.name}</Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {(file.size / 1024).toFixed(2)} KB
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <IconButton
                                                size="small"
                                                onClick={() => setFileNames(fileNames.splice(index, -1))}
                                                color="error"
                                            >
                                                <Close />
                                            </IconButton>
                                        </Box>
                                    ))}
                                </Box>
                            ) : (
                                // Show dropzone when no files
                                <Dropzone
                                    onDrop={handleDrop}
                                >
                                    {({ getRootProps, getInputProps, isDragActive }) => (
                                        <Box
                                            {...getRootProps()}
                                            sx={{
                                                border: '2px dashed',
                                                borderColor: '#D8DAEB',
                                                borderRadius: 2,
                                                padding: { xs: 3, md: 6 },
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                minHeight: 100,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <input {...getInputProps()} />
                                            <img src="/Images/sound.png" alt="upload" />
                                            <Typography fontWeight={600} gutterBottom>
                                                Drag and drop your files
                                            </Typography>
                                            <CommonButton
                                                label="Select File"
                                                color="Black"
                                                background="White"
                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                width="100px"
                                                height="40px"
                                                marginBottom="0px"
                                                marginTop="10px"
                                            />
                                        </Box>
                                    )}
                                </Dropzone>
                            )}
                        </Box>
                    </Grid>
                }
                actionButtons={(
                    <Fragment>
                        <CommonButton
                            label="Save"
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            handleClick={async () => {
                                try {
                                    dispatch(setLoading({
                                        loading: true
                                    }));
                                    const formData = new FormData();
                                    formData.append('type', testType);
                                    formData.append('created_by', user?.user_id);
                                    fileNames.map((a) => {
                                        formData.append('documents', a);
                                    })
                                    formData.append('student_id', studentId);
                                    formData.append('mentor_profile_id', user?.mentor?.mentor_profile_id);
                                    formData.append('service_offers', currentService);
                                    const response = await CreateResource(formData);
                                    if (response.success) {
                                        showNotification(response.message, 'success');
                                        setOpen(false);
                                        dispatch(setLoading({
                                            loading: false
                                        }));
                                        setFileNames([]);
                                        getResourceData();
                                    }
                                } catch (err) {
                                    const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                    showNotification(errorMessage, 'error');
                                    dispatch(setLoading({
                                        loading: false
                                    }));
                                }
                            }}
                        />
                    </Fragment>
                )}
            />
            <CommonCard
                borderRadius={1}
                border={fromMentor ? `1px solid #0000001A` : 'none'}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>{fromMentor ? 'Shared Resources' : 'Prep Resources'}</Typography>
                                {!fromMentor && (
                                    <Typography fontSize={14} color={theme.palette.background.dark}>Study materials and tools to support your preparation.</Typography>
                                )}
                            </Box>
                            {fromMentor && (
                                <CommonButton
                                    label="Add Resources"
                                    height="35px"
                                    width="160px"
                                    marginTop="0px"
                                    marginBottom="0px"
                                    startIcon={<Add />}
                                    handleClick={() => setOpen(true)}
                                />
                            )}
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Box
                        sx={{
                            height: resources.length > 0 ? '22vh' : '8vh',
                            overflow: 'auto'
                        }}
                    >
                        {resources.length > 0 ?
                            (<Box
                                sx={{
                                    height: '31vh',
                                    overflow: 'auto'
                                }}
                            >
                                {resources.map((a, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                padding="13px"
                                            >
                                                <Box>
                                                    <Typography fontSize={14} fontWeight="600">{a.filename}</Typography>
                                                    <Typography fontSize={12} color={theme.palette.background.dark}>{(a.size / 1024).toFixed(2)} KB</Typography>
                                                </Box>
                                                {!fromMentor && (
                                                    <Box display="flex" gap={1} alignItems="center" justifyContent="center"
                                                        sx={{ cursor: 'pointer' }}
                                                    >
                                                        <a
                                                            href={`${process.env.REACT_APP_BASE_URL}/file?bname=${a?.url}&download=true`}
                                                            download
                                                            target="_blank"
                                                            style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}
                                                        >
                                                            <img src="/Images/receive-square.png" alt="download" width="25px" height="25px" />
                                                        </a>
                                                    </Box>
                                                )}
                                            </Box>
                                            <Divider />
                                        </Fragment>
                                    )
                                })}
                            </Box>) : (
                                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                                    <Typography color={theme.palette.background.dark}>No Resource Found</Typography>
                                </Box>
                            )}
                    </Box>
                }
                paddingBottom="0px"
                padding="0px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default RecentActivites;